"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=26%3A1881))
 * @lastsynced 2026-10-29T13:49:45.187Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const ChatBubble = createSVGIcon(
  <path
    d="M11.997.923A11.07 11.07 0 0 0 2.239 6.77a11.08 11.08 0 0 0 .541 11.365L.923 23.077l6.218-1.125a11.072 11.072 0 0 0 15.652-7.46A11.08 11.08 0 0 0 16.81 2.022 11.1 11.1 0 0 0 11.997.923Z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "ChatBubble",
  {
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
